import { makeAutoObservable, flow, toJS } from 'mobx'
import AsyncStorage from '@react-native-community/async-storage'
import api from '../api'
import _ from 'lodash'

class ReservationStore {
    reservations = []
    reservationCount = 0
    reservationSummary = []

    constructor() {
        makeAutoObservable(this)
    }

    listReservationSummary = flow(function* (timestamp) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listReservationSummary(token, timestamp)
            this.reservationSummary = response.data
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listReservations = flow(function* (productId, time) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listReservations(token, 20, 0, productId, time)
            const { reservations, count } = response.data
            this.reservations = reservations
            this.reservationCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listMoreReservations = flow(function* (productId, time, skip) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.listReservations(token, limit = 20, skip, productId, time)
            const { reservations, count } = response.data
            this.reservations = _.union(this.reservations, reservations)
            this.reservationCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    updateReservationStatus(reservationId, status) {
        console.log('reservation store update status')
        console.log(reservationId)
        console.log(status)
        let reservations = toJS(this.reservations)
        console.log(reservations)
        const index = reservations.findIndex((f) => { return f.reservations._id == reservationId })
        if (index !== -1) {
            reservations[index].reservations.status = status
            this.reservations = reservations
            console.log(reservations)
        }
    }
}

export default new ReservationStore()